module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nome Completo",
      "prop": "nome"
    }
  }, [_c('em', [_vm._v("Nome do sócio administrador, empresário ou representante legal")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Nome Completo"
    },
    model: {
      value: (_vm.form.nome),
      callback: function($$v) {
        _vm.$set(_vm.form, "nome", $$v)
      },
      expression: "form.nome"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Telefone Fixo",
      "prop": "telefone"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.telefone),
      expression: "form.telefone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(99) 9999-9999'),
      expression: "'(99) 9999-9999'"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": "(99) 9999-9999"
    },
    domProps: {
      "value": (_vm.form.telefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "telefone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Celular",
      "prop": "celular"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.celular),
      expression: "form.celular"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(99) 99999-9999'),
      expression: "'(99) 99999-9999'"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": "(99) 99999-9999"
    },
    domProps: {
      "value": (_vm.form.celular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "celular", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CPF",
      "prop": "cpf"
    }
  }, [_c('em', [_vm._v("CPF do sócio administrador da empresa ou solicitante")]), _vm._v(" "), _c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cpf),
      expression: "form.cpf"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('999.999.999-99'),
      expression: "'999.999.999-99'"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": "999.999.999-99"
    },
    domProps: {
      "value": (_vm.form.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "cpf", $event.target.value)
      }
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f2f66e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConstituicaoDeEmpresa/Solicitante.vue
// module id = 199
// module chunks = 1